import i18next from 'i18next';
import ptBR from './pt-br/translation.json';

i18next.init({
  lng: 'pt-BR',
  interpolation: {
    escapeValue: false,
  },
  resources: {
    'pt-BR': ptBR,
  },
});

export default i18next;
